<template>
  <!-- Content Wrapper. Contains page content -->
  <div class="content-wrapper">
    <!-- Content Header (Page header) -->
    <div class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-2">
            <h1 class="m-0">İnsiyatif Sorgulama</h1>
          </div>
          <div class="col-md-8">
            <form @submit.prevent="search">
              <div class="input-group">
                <input
                  type="search"
                  @blur="$v.code.$touch()"
                  v-model="$v.code.$model"
                  class="form-control"
                  placeholder="Müşteri ID"
                  :class="{ 'is-invalid': $v.code.$error }"
                />

                <select
                  v-model="site"
                  @change="siteChange"
                  class="form-control col-3"
                >
                  <option
                    v-for="item in $store.getters.getSites"
                    :key="item.slug"
                    :value="item.slug"
                  >
                    {{ item.name }}
                  </option>
                </select>
                <div class="input-group-append">
                  <button
                    type="button"
                    @click="search"
                    class="btn btn-default"
                    :disabled="$v.$invalid"
                  >
                    <i class="fa fa-search"></i>
                  </button>
                </div>
              </div>
              <small
                v-if="!$v.code.required && $v.code.$error"
                class="form-text text-danger"
                >Bu alan zorunludur...</small
              >
              <!-- <small v-if="!$v.code.numeric" class="form-text text-danger"
                >Lütfen sadece rakam giriniz...</small
              >-->

              <small
                v-if="!$v.code.minLength && $v.code.$error"
                class="form-text text-danger"
                >Lütfen müşteri ID en az
                {{ $v.code.$params.minLength.min }} karakterden oluşmalıdır...
              </small>
              <small
                v-if="!$v.code.maxLength && $v.code.$error"
                class="form-text text-danger"
                >Lütfen müşteri ID en fazla
                {{ $v.code.$params.maxLength.max }} karakterden oluşmalıdır...
              </small>
            </form>
          </div>
          <!-- /.col -->
          <div class="col-sm-2">
            <ol class="breadcrumb float-sm-right">
              <router-link tag="li" to="/" class="breadcrumb-item"
                ><a>Anasayfa</a></router-link
              >
              <li class="breadcrumb-item active">İnsiyatif Sorgula</li>
            </ol>
          </div>
          <!-- /.col -->
        </div>
        <!-- /.row -->
      </div>
      <!-- /.container-fluid -->
    </div>
    <!-- /.content-header -->

    <!-- Main content -->
    <div class="content">
      <div class="container-fluid">
        <div class="row">
          <div class="col-lg-12">
            <div class="card">
              <div class="card-header">
                <div class="row">
                  <div class="col-7">Sorgu Detayları</div>
                  <div class="col-5">Sıradaki Sorgulama Talepleri</div>
                </div>
              </div>
              <div class="card-body" style="height: 700px">
                <div class="row">
                  <div class="col-7">
                    <router-view></router-view>
                  </div>
                  <div
                    class="col-5"
                    style="
                      max-height: 660px;
                      overflow-x: hidden;
                      overflow-y: scrool;
                    "
                  >
                    <div class="overlay-wrapper">
                      <div class="overlay" v-if="datas.length == 0">
                        <i class="fas fa-3x fa-spinner fa-spin"></i>
                      </div>
                    </div>
                    <ul class="list-group" id="requests">
                      <li
                        v-for="item in datas"
                        :key="item.id"
                        class="list-group-item"
                      >
                        {{ item.code }} ( {{ item.date | DateFormat }} )
                        <button
                          class="btn btn-sm btn-outline-secondary float-right"
                          disabled
                          v-if="!item.ready && !item.status"
                        >
                          <i class="fas fa-spinner fa-spin"></i> Sırada Bekliyor
                        </button>
                        <button
                          class="btn btn-sm btn-outline-primary float-right"
                          disabled
                          v-if="item.ready && !item.status"
                        >
                          <i class="fas fa-spinner fa-spin"></i> Müşteri
                          Taranıyor
                        </button>
                        <router-link
                          :to="'/insiyatif-search/' + item.id"
                          tag="button"
                          class="btn btn-sm btn-outline-primary float-right"
                          v-if="item.status"
                          ><i class="fas fa-eye"></i> Raporu İncele</router-link
                        >
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- /.row -->
      </div>
      <!-- /.container-fluid -->
    </div>
    <!-- /.content -->
  </div>
  <!-- /.content-wrapper -->
</template>

<script>
import {
  required,
  minLength,
  maxLength,
  numeric,
} from "vuelidate/lib/validators";

export default {
  data() {
    return {
      site: this.$store.getters.getSite,
      code: "",
      datas: this.$store.getters.getInsiyatifData,
      service: this.$store.getters.getHub,
    };
  },
  validations: {
    code: {
      required,
      minLength: minLength(8),
      maxLength: maxLength(15),
      // numeric,
    },
  },
  methods: {
    getList() {
      if ($.connection.hub.state === $.signalR.connectionState.disconnected) {
        $.connection.hub
          .start({ jsonp: true })
          .done(() => {
            this.service.server.getListInsiyatif(this.site);
          })
          .fail((err) => {
            console.log(err);
          });
      } else {
        this.service.server.getListInsiyatif(this.site);
      }
    },
    signalr() {
     
      /*this.service.client.lastRequestInsiyatif = (datas) => {
        this.$store.commit("setInsiyatifData", datas);
      };*/
      this.getList();
    },
    search() {
      if (this.$v.$invalid) return 0;

      this.$http.get("Bonus/RequestInsiyatif/" + this.code.trim()).then(
        (response) => {
          toastr.success("İnsiyatif hesaplama talebiniz başarıyla alındı.");
          this.service.server.getListInsiyatif(this.site);
          this.code = "";
          this.$v.$reset();
        },
        (err) => {
          toastr.error(err.data.Message);
        }
      );
    },
    siteChange() {
      this.$store.commit("setSite", this.site);
    },
  },
  filters: {
    DateFormat(value) {
      if (!value) return "Giriş Yapılmamış";

      let date = value.split("T")[0].split("-");
      let time = value.split("T")[1].split(".")[0];
      return date[2] + "/" + date[1] + "/" + date[0] + " " + time;
    },
  },
  created() {
    this.signalr();
  },

  watch: {
    "$store.getters.getSite"() {
      this.site = this.$store.getters.getSite;
      this.getList();
    },
    "$store.getters.getInsiyatifData"() {
      this.datas = this.$store.getters.getInsiyatifData;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Insiyatif/Insiyatif.vue